import { CommonHelper } from './commonHelper';

// Temporary restriction: remove when organisation 4629 requests that it be undone.
export const isRestrictedBrandAdmin = () => {
  const permissions = CommonHelper.GetBrandInfoFromLocalStorage('permissions');
  return (
    Number(CommonHelper.GetBrandInfoFromLocalStorage('org_id')) === 4629 &&
    !!permissions?.[CommonHelper.PermissionList.BRAND_ADMIN] &&
    !permissions?.[CommonHelper.PermissionList.ORG_ADMIN]
  );
};

const restrictedPaths = [
  '/manage-organization',
  '/manage-org-users',
  '/manage-users',
  '/pending-users',
  '/handle-api',
];

export const canAccessSettingsPath = (path = '') =>
  !isRestrictedBrandAdmin() || !restrictedPaths.includes(path.replace(/\/+$/, ''));
